/* カートの合わせ買い（セットだけ）の「追加 ＋」（2026-10-06）。snippets/kazu-cart-sets.liquid の [data-kcs-add]。
   オーナー「一個売りとかじゃなくて、セット売りがいいでしょ」「足りないからこれ買ってオーバーする合わせ買いの仕方がいい」→「おすすめで進めて」
   ・1タップで /cart/add.js に items[]（1点、または献立の2点）を送る。カートのページから離れない。
   ・/cart のページでは、入ったら /cart を読み直す（location.reload：Prestige が /cart で数量を変えたときと同じ。見ていた位置のまま、並び・特典・合計はサーバーで作り直す）。
   ・ほかのページ（引き出しカート）では /cart.js を取り直し、cart:change（force_open_drawer）で中身を描き直す（kz-buy.js と同じ形）。描き直した欄に「追加しました」を出す。
   ・断られたとき：1点の4xxは「入っていない」。2点の4xxは、送る前と後の /cart.js の数を比べ、どちらも増えていなければ「入っていない」。
     どちらもその場に Shopify の説明を出してボタンを戻す。
   ・入ったか分からないとき（通信の失敗・5xx・2点のうち片方が入った・描き直しの失敗）は再送せず /cart を開く。二度押しは受けない。
   ・「戻る」でページが bfcache から戻ったら（pageshow persisted）、押せる状態に戻す。
   ・引き出しの中身は差し替わるので、document で1回だけクリックを受ける。 */
(() => {
  'use strict';
  if (window.kazuCartSets) return;
  window.kazuCartSets = true;
  const html = document.documentElement;
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const wait = (ms) => (window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(ms) : undefined);
  const settings = () => (window.themeVariables && window.themeVariables.settings) || {};
  const onCartPage = () => settings().pageType === 'cart';
  const reloadsCart = () => onCartPage() || settings().cartType === 'page';
  const openCart = () => { if (onCartPage()) location.reload(); else location.assign(base + 'cart'); };
  const parse = (value) => String(value || '').split(',').map((pair) => {
    const [id, quantity] = pair.split(':').map(Number);
    return { id, quantity: quantity || 1 };
  }).filter((item) => Number.isInteger(item.id) && item.id > 0 && Number.isInteger(item.quantity) && item.quantity > 0);
  // variant_id → 数量。読めなければ null（そのときは「分からない」扱い）
  const quantities = async () => {
    try {
      const res = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: wait(8000) });
      if (!res.ok) return null;
      const cart = await res.json();
      const map = new Map();
      (cart.items || []).forEach((line) => map.set(line.variant_id, (map.get(line.variant_id) || 0) + line.quantity));
      return map;
    } catch (error) {
      return null;
    }
  };
  const lockAll = (on) => document.querySelectorAll('[data-kcs-add]').forEach((b) => { b.disabled = on; });
  const say = (block, text, tone) => {
    const status = block && block.querySelector('[data-kcs-status]');
    if (!status) return;
    status.classList.toggle('kcs__status--ok', tone === 'ok');
    status.textContent = text || '';
    status.hidden = !text;
  };
  let adding = false;

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    adding = false;
    lockAll(false);
    document.querySelectorAll('[data-kcs-add][aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
    document.querySelectorAll('[data-kcs]').forEach((block) => say(block, ''));
  });

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-kcs-add]') : null;
    if (!button) return;
    event.preventDefault();
    if (adding) return;
    const items = parse(button.dataset.items);
    if (!items.length) return;
    const block = button.closest('[data-kcs]');
    adding = true;
    lockAll(true);
    button.setAttribute('aria-busy', 'true');
    say(block, 'カートに入れています…');
    let accepted = false;
    let definite = false;
    let leaving = false;
    try {
      const before = items.length > 1 ? await quantities() : null;
      const sections = [];
      if (!reloadsCart()) html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const res = await fetch(base + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }),
        signal: wait(20000)
      });
      const result = await res.json().catch(() => ({}));
      if (!res.ok) {
        if (res.status >= 400 && res.status < 500) {
          if (items.length === 1) {
            definite = true; // 1点（数量1）の4xxは「断られた」
          } else if (before) {
            // 2点：片方だけ入った可能性があるので、送る前と数を比べる。どちらも増えていなければ「断られた」
            const after = await quantities();
            definite = !!after && items.every((item) => (after.get(item.id) || 0) <= (before.get(item.id) || 0));
          }
        }
        throw new Error(result.description || 'カートに入れられませんでした');
      }
      accepted = true;
      if (reloadsCart()) { leaving = true; openCart(); return; }
      const cr = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: wait(12000) });
      if (!cr.ok) throw new Error('cart-refresh');
      const cart = await cr.json();
      if (!sections.length || sections.some((id) => !(result.sections && result.sections[id]))) throw new Error('section-refresh');
      cart.sections = result.sections;
      // 引き出しは中身が差し替わり「カートに入れています…」も消えるので、描き直した欄に知らせを出す（Prestige は描き直しのあと cart-drawer:refreshed を出す）
      const announce = () => {
        document.removeEventListener('cart-drawer:refreshed', announce);
        const fresh = document.querySelector('cart-drawer [data-kcs]');
        if (fresh) say(fresh, '追加しました', 'ok');
      };
      document.addEventListener('cart-drawer:refreshed', announce);
      setTimeout(() => document.removeEventListener('cart-drawer:refreshed', announce), 5000);
      html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
    } catch (error) {
      if (accepted || !definite) {
        leaving = true;
        say(block, '入ったかを確かめるため、カートを開きます');
        openCart();
      } else {
        say(block, error.message);
      }
    } finally {
      if (!leaving) {
        adding = false;
        lockAll(false);
        button.removeAttribute('aria-busy');
      }
    }
  });
})();
